import React, { useState } from "react";
import { login, changePassword, PORTAL, pedirRestablecerClave, restablecerClave } from "../api";
import { errMsg } from "../utils";
import { RepIcon } from "./RepuestosUI";

const LOGO = process.env.PUBLIC_URL + "/fs-black.png";
const MIN_LENGTH = 8;

function LoginFrame({ children }) {
  if (PORTAL !== "repuestos") return <div className="login-wrap">{children}</div>;
  return <div className="repuestos-login"><aside className="rep-login-story"><div className="rep-brand"><span className="rep-brand-symbol"><img src={LOGO} alt=""/></span><span><strong>ALAS<span className="rep-brand-dot">.</span></strong><small>Portal de proveedores</small></span></div><div className="rep-login-intro"><span className="rep-login-eyebrow">PROVEEDORES DE REPUESTOS</span><h2>Autorizaciones y facturas,<br/>en un solo lugar.</h2><p>Una forma clara de gestionar sus autorizaciones y seguir cada factura hasta su aprobación.</p><ol><li><span><RepIcon name="document"/></span><div><strong>Reciba sus autorizaciones</strong><p>Consulte el vehículo, los repuestos y el valor.</p></div></li><li><span><RepIcon name="upload"/></span><div><strong>Presente sus facturas</strong><p>Adjunte los documentos desde cualquier dispositivo.</p></div></li><li><span><RepIcon name="check"/></span><div><strong>Siga cada revisión</strong><p>Consulte novedades, correcciones y aprobaciones.</p></div></li></ol></div><div className="rep-login-story-footer">ALAS · Gestión de proveedores</div></aside><main className="rep-login-main"><div className="rep-login-mobile-brand"><img src={LOGO} alt=""/><strong>ALAS<span>Proveedores</span></strong></div>{children}<p className="rep-login-footer"><RepIcon name="shield" size={15}/>Acceso exclusivo para proveedores autorizados</p></main></div>;
}

// Token del enlace «crear contraseña nueva» que llega al correo (?restablecer=…).
function tokenDelEnlace() {
  try { return new URLSearchParams(window.location.search).get("restablecer") || ""; } catch { return ""; }
}

function quitarTokenDelEnlace() {
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete("restablecer");
    window.history.replaceState(null, "", url.pathname + url.search + url.hash);
  } catch { /* nada */ }
}

/** Proveedores: pedir el enlace con el correo registrado (respuesta siempre igual). */
function OlvideClave({ onVolver }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  async function submit(e) {
    e.preventDefault();
    if (!email.trim()) { setError("Escriba el correo registrado de su cuenta."); return; }
    setLoading(true); setError("");
    try {
      const r = await pedirRestablecerClave(email);
      setMsg(r?.detail || "Si el correo está registrado, le llegará un enlace para crear una contraseña nueva.");
    } catch (e2) {
      setError(errMsg(e2, "No se pudo enviar la solicitud. Intente de nuevo."));
    } finally { setLoading(false); }
  }
  return (
    <LoginFrame>
      <form className="login-card" onSubmit={submit}>
        <div className="login-logo">
          <span className="badge-logo"><img src={LOGO} alt="ALAS" /></span>
          <h1>¿Olvidó su contraseña?</h1>
          <div className="sub">Escriba el correo con el que ingresa al portal. Le enviaremos un enlace para crear una contraseña nueva.</div>
        </div>
        {msg && <div className="banner info" role="status">{msg}</div>}
        {error && <div className="banner err" role="alert">{error}</div>}
        {!msg && <>
          <label htmlFor="reset-email">Correo electrónico</label>
          <input id="reset-email" type="email" inputMode="email" autoComplete="username" autoCapitalize="none"
                 value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nombre@empresa.com" />
          <button className="btn" style={{ marginTop: 24 }} disabled={loading}>{loading ? "Enviando…" : "Enviarme el enlace"}</button>
        </>}
        <button type="button" className="btn-sm ghost" style={{ marginTop: 16 }} onClick={onVolver}>Volver al ingreso</button>
      </form>
    </LoginFrame>
  );
}

/** Proveedores: crear la contraseña nueva desde el enlace del correo. */
function RestablecerClave({ token, onListo, onPedirOtro }) {
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  async function submit(e) {
    e.preventDefault();
    if (p1.length < MIN_LENGTH) { setError(`La contraseña debe tener al menos ${MIN_LENGTH} caracteres.`); return; }
    if (p1 !== p2) { setError("Las contraseñas no coinciden."); return; }
    setLoading(true); setError("");
    try {
      const r = await restablecerClave(token, p1);
      quitarTokenDelEnlace();
      onListo(r?.detail || "Su contraseña quedó cambiada. Ya puede ingresar.");
    } catch (e2) {
      setError(errMsg(e2, "No se pudo cambiar la contraseña."));
      setLoading(false);
    }
  }
  return (
    <LoginFrame>
      <form className="login-card" onSubmit={submit}>
        <div className="login-logo">
          <span className="badge-logo"><img src={LOGO} alt="ALAS" /></span>
          <h1>Crear contraseña nueva</h1>
          <div className="sub">Escriba su contraseña nueva (mínimo {MIN_LENGTH} caracteres) y confírmela.</div>
        </div>
        {error && <div className="banner err" role="alert">{error}</div>}
        <label htmlFor="new-pass">Contraseña nueva</label>
        <input id="new-pass" type="password" autoComplete="new-password" value={p1} onChange={(e) => setP1(e.target.value)} />
        <label htmlFor="new-pass-2">Confirmar contraseña</label>
        <input id="new-pass-2" type="password" autoComplete="new-password" value={p2} onChange={(e) => setP2(e.target.value)} />
        <button className="btn" style={{ marginTop: 24 }} disabled={loading}>{loading ? "Guardando…" : "Guardar contraseña"}</button>
        <button type="button" className="btn-sm ghost" style={{ marginTop: 16 }}
                onClick={() => { quitarTokenDelEnlace(); onPedirOtro(); }}>Pedir otro enlace</button>
      </form>
    </LoginFrame>
  );
}

/** Pantalla de ingreso: email + contraseña. */
export function Login(props) {
  const [modo, setModo] = useState(() => (PORTAL === "repuestos" && tokenDelEnlace() ? "restablecer" : "login"));
  const [aviso, setAviso] = useState("");
  if (PORTAL === "repuestos" && modo === "olvide") {
    return <OlvideClave onVolver={() => setModo("login")} />;
  }
  if (PORTAL === "repuestos" && modo === "restablecer") {
    return <RestablecerClave token={tokenDelEnlace()} onListo={(m) => { setAviso(m); setModo("login"); }}
                             onPedirOtro={() => setModo("olvide")} />;
  }
  return <LoginForm {...props} info={aviso || props.info} onOlvide={() => setModo("olvide")} />;
}

function LoginForm({ info, onDone, onMustChange, onOlvide }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!email.trim() || !password) {
      setError("Ingresa tu correo y contraseña.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await login(email, password);
      if (res.mustChange) {
        // El backend exige cambio de contraseña antes de emitir token.
        onMustChange(email.trim(), password);
        return;
      }
      onDone();
    } catch (e2) {
      const status = e2?.response?.status;
      if (status === 401) {
        setError("Correo o contraseña incorrectos.");
      } else if (status === 423) {
        // Usuario bloqueado temporalmente: mostrar el mensaje del backend.
        setError(errMsg(e2, "Usuario bloqueado temporalmente. Intenta más tarde."));
      } else {
        setError(errMsg(e2, "No se pudo iniciar sesión."));
      }
      setLoading(false);
    }
  }

  return (
    <LoginFrame>
      <form className="login-card" onSubmit={submit}>
        <div className="login-logo">
          <span className="badge-logo"><img src={LOGO} alt="ALAS" /></span>
          <h1>{PORTAL === "repuestos" ? "Bienvenido a su portal" : "Portal de Proveedores"}</h1>
          <div className="sub">
            {PORTAL === "repuestos" ? "Ingrese con el correo y la contraseña de su cuenta." : "ALAS · Reservas de convenio"}
          </div>
        </div>

        {info && !error && <div className="banner info" role="status">{info}</div>}
        {error && <div className="banner err" role="alert">{error}</div>}

        <label htmlFor="provider-email">Correo electrónico</label>
        <input
          id="provider-email"
          type="email"
          inputMode="email"
          autoComplete="username"
          autoCapitalize="none"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="nombre@empresa.com"
        />

        <label htmlFor="provider-password">Contraseña</label>
        <div className={PORTAL === "repuestos" ? "rep-login-password" : undefined}>
        <input
          id="provider-password"
          type={showPassword ? "text" : "password"}
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Ingrese su contraseña"
        />
        {PORTAL === "repuestos" && <button type="button" aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"} onClick={() => setShowPassword((v) => !v)}>{showPassword ? "Ocultar" : "Mostrar"}</button>}
        </div>

        <button className="btn" style={{ marginTop: 24 }} disabled={loading}>
          {loading ? "Ingresando…" : PORTAL === "repuestos" ? "Ingresar al portal" : "Entrar"}{PORTAL === "repuestos" && <RepIcon name="arrow" size={18}/>}
        </button>
        {PORTAL === "repuestos" && <button type="button" className="btn-sm ghost" style={{ marginTop: 14 }} onClick={onOlvide}>¿Olvidó su contraseña?</button>}
        {PORTAL === "repuestos" && <div className="rep-login-help"><RepIcon name="info" size={17}/><p>Su usuario es el correo que tiene registrado con la empresa. Si olvidó la contraseña, use «¿Olvidó su contraseña?»; para un acceso nuevo, comuníquese con el área que administra sus autorizaciones.</p></div>}
      </form>
    </LoginFrame>
  );
}

/**
 * Cambio de contraseña OBLIGATORIO (must_change_password en el login).
 * Cambia con /auth/change-password y luego intenta el auto-login con la
 * contraseña nueva; si ese segundo paso falla, vuelve al login con aviso.
 */
export function ChangePassword({ email, currentPassword, onDone, onBackToLogin }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function submit(e) {
    e.preventDefault();
    setError("");
    if (newPassword.length < MIN_LENGTH) {
      setError(`La nueva contraseña debe tener al menos ${MIN_LENGTH} caracteres.`);
      return;
    }
    if (newPassword !== confirm) {
      setError("Las contraseñas no coinciden.");
      return;
    }
    if (newPassword === currentPassword) {
      setError("La nueva contraseña debe ser diferente a la actual.");
      return;
    }
    setLoading(true);

    // Paso 1: cambiar la contraseña.
    try {
      await changePassword(email, currentPassword, newPassword);
    } catch (e2) {
      setError(errMsg(e2, "No se pudo cambiar la contraseña."));
      setLoading(false);
      return;
    }

    // Paso 2: la contraseña YA se cambió; auto-login para no pedirla de nuevo.
    try {
      const res = await login(email, newPassword);
      if (res.mustChange) throw new Error("Cambio no aplicado");
      onDone();
    } catch {
      onBackToLogin("Tu contraseña fue cambiada. Ingresa con tu nueva contraseña.");
    }
  }

  return (
    <LoginFrame>
      <form className="login-card" onSubmit={submit}>
        <div className="login-logo">
          <span className="badge-logo"><img src={LOGO} alt="ALAS" /></span>
          <h1>Cambia tu contraseña</h1>
          <div className="sub">Por seguridad debes actualizarla antes de continuar.</div>
        </div>

        <div className="banner info">
          🔒 Mínimo {MIN_LENGTH} caracteres y distinta a la anterior.
        </div>

        {error && <div className="banner err">{error}</div>}

        <label htmlFor="provider-new-password">Nueva contraseña</label>
        <input
          id="provider-new-password"
          type="password"
          autoComplete="new-password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="Nueva contraseña"
          autoFocus
        />

        <label htmlFor="provider-confirm-password">Confirmar contraseña</label>
        <input
          id="provider-confirm-password"
          type="password"
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          placeholder="Repite la contraseña"
        />

        <button className="btn" style={{ marginTop: 24 }} disabled={loading}>
          {loading ? "Guardando…" : "Guardar y continuar"}
        </button>
        <button
          type="button"
          className="btn ghost"
          style={{ marginTop: 10 }}
          onClick={() => onBackToLogin("")}
          disabled={loading}
        >
          Volver al inicio de sesión
        </button>
      </form>
    </LoginFrame>
  );
}
